import React__default from 'react';
import { browser } from '@bilibili-maoer/web-utils';
import GridLegacy from './grid-legacy.js';
import styleModules from './style/main.module.scss.js';

var Grid = function Grid(_ref) {
  var gap = _ref.gap,
      columns = _ref.columns,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styleModules.grid,
    style: {
      '--me-grid-columns': columns,
      '--me-grid-gap-x': gap === null || gap === void 0 ? void 0 : gap.x,
      '--me-grid-gap-y': gap === null || gap === void 0 ? void 0 : gap.y
    }
  }, children));
};

var useLegacy = browser.getBrowserInfo().type === browser.BrowserType.IE;
var GridComponent = useLegacy ? GridLegacy : Grid;

var ConditionGrid = function ConditionGrid(props) {
  return GridComponent(props);
};

export { ConditionGrid as default, useLegacy };
